import { render, staticRenderFns } from "./HandleCountryTabGeneral.vue?vue&type=template&id=02bce188"
import script from "./HandleCountryTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleCountryTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleCountryTabGeneral.vue?vue&type=style&index=0&id=02bce188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports